import { LANGUAGES } from 'commons/constants/language'

export const PaymentPageTermsUrls = {
	[LANGUAGES.FRENCH]: 'https://support.lydia.me/l/fr/article/d7b3jbxvdz',
	[LANGUAGES.ENGLISH]: 'https://support.lydia.me/l/en/article/d7b3jbxvdz'
}

export const PrivacyPolicyUrls = {
	[LANGUAGES.FRENCH]:
		'https://support.lydia.me/l/fr/article/q85z5imn58-politique-de-protection-des-donnees-personnelles-lydia-solutions',
	[LANGUAGES.ENGLISH]: 'https://support.lydia.me/l/en/article/q85z5imn58-lydia-privacy-policy'
}

export const ReportMoneyPotUrls = {
	[LANGUAGES.FRENCH]:
		'https://support.lydia.me/l/fr/article/7nayekoqx4-signaler-une-cagnotte-lydia',
	[LANGUAGES.ENGLISH]: 'https://support.lydia.me/l/en/article/7nayekoqx4-report-a-money-pot'
}
